import React from "react";
import { Page } from "../components/layout";
import { Accent } from "../components/typography";

const ProjectPage = () => (
  <Page>
    <title>LastTalon</title>
    <h1>
      Project
      <br />
      <Accent>— coming soon!</Accent>
    </h1>
    <p>This page is currently under construction.</p>
  </Page>
);

export default ProjectPage;
